import { Flex, Image } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Header from 'features/Onboarding/components/Header';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import OBStickyButton from 'features/Onboarding/components/OBStickyButton/OBStickyButton';
import ShineStartNextStepsList from 'features/Onboarding/legacy/components/ShineStartNextStepsList';

import HandwrittenProofOfIdentityEN from './assets/HandwrittenProofOfIdentityEN.jpg';
import HandwrittenProofOfIdentityFR from './assets/HandwrittenProofOfIdentityFR.jpg';
import locales from './locales';

const language = locales.getLanguage();

interface HandwrittenIdentityInfoProps {
  onNext: () => void;
}
const HandwrittenIdentityInfo = asBentoPage<HandwrittenIdentityInfoProps>(
  ({ Layout, onNext, onPrev }) => {
    const getSource = () =>
      language === 'en'
        ? HandwrittenProofOfIdentityEN
        : HandwrittenProofOfIdentityFR;

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Header description={locales.description} title={locales.title} />

        <Flex alignItems="center" flexDirection="column">
          <Image
            alt={locales.exampleDocumentImageAlt}
            marginBottom="space-32"
            src={getSource()}
            width="full"
          />

          <ShineStartNextStepsList orderedSteps={locales.nextSteps} />

          <OBStickyButton onClick={onNext}>
            {locales.ctaButtonLabel}
          </OBStickyButton>
        </Flex>
      </Layout>
    );
  },
);

export default HandwrittenIdentityInfo;
